export enum SessionEvent {
    TokenMaxLifetimeReached = "tokenMaxLifetimeReached",
    TokenAutoUpdateFailed = "tokenAutoUpdateFailed",
    TokenUpdated = "tokenUpdated"
}





export interface SessionEventsType {
    tokenMaxLifetimeReached: (newTokenDateExpired: Date) => void;
    tokenAutoUpdateFailed: () => void;
    tokenUpdated: (newToken: string, newRefreshToken?: string) => void;
    [key: string]: (...args: any[]) => void;
}
